import { isCompatible, navigateToBrowserCompat } from "./common";

const searchParams = new URLSearchParams(location.search);
const isSkipCheck = searchParams.get("skip_check") === "true";

if (!(isSkipCheck || isCompatible())) {
	navigateToBrowserCompat(location.href);
}
